import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

type InputFieldProps = {
  id: string;
  label: string;
  type: string;
  placeholder: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void; // Updated type
  required?: boolean;
  className?: string;
  pattern?: string;
  title?: string;
  onPaste?: (e: React.ClipboardEvent<HTMLInputElement>) => void;
  autoComplete?: string;
  style?: React.CSSProperties;
  minLength?: number;
  maxLength?: number;
};

const InputField: React.FC<InputFieldProps> = ({
  id,
  label,
  type,
  placeholder,
  value,
  onChange,
  onKeyDown,  // Added here
  required = false,
  className = '',
  pattern,
  title,
  onPaste,
  autoComplete,
  style,
  minLength,
  maxLength,
}) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const handlePasswordVisibilityToggle = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  const inputType = type === 'password' && isPasswordVisible ? 'text' : type;

  return (
    <div className={`input-field ${className}`}>
      <label htmlFor={id} className="block text-sm font-medium text-dark-blue">
        {label}
      </label>
      <div className="relative">
        <input
          id={id}
          type={inputType}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}  // Added here
          onPaste={onPaste}
          autoComplete={autoComplete}
          required={required}
          className="mt-1 block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-light-blue focus:border-light-blue sm:text-sm"
          pattern={pattern}
          title={title}
          style={style}
          minLength={minLength}
          maxLength={maxLength}
        />
        {type === 'password' && (
          <span
            className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
            onClick={handlePasswordVisibilityToggle}
          >
            <FontAwesomeIcon icon={isPasswordVisible ? faEyeSlash : faEye} className="w-5 h-5"/>
          </span>
        )}
      </div>
    </div>
  );
};

export default InputField;
